import ScalarIconTerminalWindow_vue_vue_type_script_setup_true_lang_default from "./ScalarIconTerminalWindow.vue_vue_type_script_setup_true_lang.js";
//#region src/components/ScalarIconTerminalWindow.vue
var ScalarIconTerminalWindow_default = ScalarIconTerminalWindow_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarIconTerminalWindow_default as default };

//# sourceMappingURL=ScalarIconTerminalWindow.js.map